export default __webpack_public_path__ + "static/background-pattern-0953df5a7ed852d41be62c5fbd79e698.png";